import {
  isDateLessThan5Years,
  isDateMoreThan5Years,
} from '@shared/fondof-fn/date/check'
import { i18nPrice } from '@shared/fondof-fn/format/price'
import { gidToId } from '@shared/shop-api/core/helper'
import { toVariantAttributes } from '@shared/shop-api/product/variants/attributes/mapper'
import type { ProductVariantFragment } from '@shared/types/storefront/graphql'

export const toProductVariant = (productVariant: ProductVariantFragment) => {
  const price = parseFloat(productVariant.price.amount)
  const originalPrice = parseFloat(
    productVariant.compareAtPrice?.amount ?? productVariant.price.amount
  )
  const discount =
    price === 0 ? 100 : Math.round(100 - (price * 100) / originalPrice)
  const size = productVariant.selectedOptions?.find(
    (option) => option.name.toLowerCase() === 'size'
  )?.value

  const attributes = toVariantAttributes(productVariant.metafields)

  const isComingSoonRestock =
    isDateLessThan5Years(attributes?.restockDate) &&
    !productVariant.availableForSale

  const isComingSoonLaunch = isDateLessThan5Years(attributes?.launchDate)

  const isComingSoon =
    isDateMoreThan5Years(attributes?.restockDate) ||
    isDateMoreThan5Years(attributes?.launchDate)

  return {
    id: gidToId(productVariant.id),
    sku: productVariant.sku ?? '',
    available: productVariant.availableForSale,
    quantityAvailable: productVariant.quantityAvailable ?? undefined,
    priceFormatted: i18nPrice(price, productVariant.price.currencyCode),
    price,
    originalPriceFormatted: i18nPrice(
      originalPrice,
      productVariant.price.currencyCode
    ),
    gtin: productVariant.gtin ?? undefined,
    originalPrice,
    discount,
    isOffer: price !== originalPrice,
    currencyCode: productVariant.price.currencyCode,
    size,
    displaySize:
      size === 'one_size' ? undefined : size?.toUpperCase()?.replace('_', '/'),
    specialPriceTo: attributes.specialPriceTo,
    specialPriceFrom: attributes.specialPriceFrom,
    specialPrice: attributes.specialPrice,
    shoeSizeWidth: attributes.shoeSizeWidth,
    bestPriceTimestamp: attributes.bestPriceTimestamp,
    bestPrice: attributes.bestPrice,
    depth: attributes.depth,
    height: attributes.height,
    width: attributes.width,
    weight: attributes.weight,
    volume: attributes.volume,
    launchDate: attributes?.launchDate,
    restockDate: attributes?.restockDate,
    isComingSoonRestock,
    isComingSoonLaunch,
    isComingSoon,
  }
}
